import { useMutation } from 'react-query';
import { getXls } from '../../../../../../api/services/mediaPlanning/generateXls';

const useGenerateXls = () => {
  const {
    mutate: generateXls,
    isLoading,
    isError,
  } = useMutation(async (planId?: string) => {
    const timestamp = Date.now();
    const fileName = `plan-summary-${timestamp}.xlsx`;
    const type =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if (!planId) {
      return;
    }

    try {
      const base64Data = await getXls({ planId });
      const base64Response = await fetch(`data:${type};base64,${base64Data}`);
      const blob = await base64Response.blob();

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(link.href);
      link.remove();
    } catch (error) {
      console.error('Error during file download:', error);
    }
  });

  return {
    generateXls,
    isLoading,
    isError,
  };
};

export default useGenerateXls;
